import { createFileRoute } from '@tanstack/react-router';

import { guardPermitAdminRoute } from '../modules/Permits/permitAdminRouteGuard';
import { PermitDetailsPage } from '../modules/Permits/PermitsAdminPage/PermitGroupDetails/PermitDetails/PermitDetailsPage';
import { assertIds, toId } from '../modules/Permits/routeParams';

// Its own page with Back to the group (86bc85juw), so it renders outside the
// /permitting list layout.
export const Route = createFileRoute('/permitting_/$permitGroupId_/permits/$permitId')({
  component: RouteComponent,
  params: {
    parse: (params) => ({
      permitGroupId: toId(params.permitGroupId),
      permitId: toId(params.permitId),
    }),
    stringify: (params) => ({
      permitGroupId: String(params.permitGroupId),
      permitId: String(params.permitId),
    }),
  },
  loader({ context, params }) {
    guardPermitAdminRoute(context.authContext.user);
    assertIds(params.permitGroupId, params.permitId);
  },
  head() {
    return {
      meta: [{ title: 'Permit' }],
    };
  },
});

function RouteComponent() {
  const { permitGroupId, permitId } = Route.useParams();
  return <PermitDetailsPage permitGroupId={permitGroupId} permitId={permitId} />;
}
